module.exports = "<div class=\"modal-header\">\r\n    <h4 class=\"modal-title\">{{'texto.sesionFinalizadaLabel' | translate}}</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n    <small>{{'texto.laSesionHaTerminado' | translate}}, <strong> {{'texto.iniciaSesionNuevamente' | translate}}.</strong></small>\r\n</div>\r\n<div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-light  btn-sm\" (click)=\"closeModal(x)\">{{'texto.aceptarLabel' | translate}}</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.html
// module id = ./src/app/components/logout/logout.component.html
// module chunks = main